import { Message } from 'components/message'
import React from 'react'

export interface MessagePageProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {}

const MessagePage = ({ children, ...props }: MessagePageProps) => {
  return (
    <div
      className="flex-1 flex flex-col items-center justify-center"
      {...props}
    >
      <Message>{children}</Message>
    </div>
  )
}

export default MessagePage
